import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ServicePortalApi } from '../../../api/api';
import { TokenMapper } from '../../../api/types';
import { SynButtonComponent, SynIconComponent } from '@synergy-design-system/angular';
import { ColumnDescription, TableComponent } from '../../components/table';

@Component({
  selector: 'app-token-mappers',
  template: `
    <div class="flex-row gap-2 align-center margin-bottom-1">
      <p i18n="@@client-token-mappers-description">
        Map some properties into the user's token.
        You can map user attributes, e.g. customer number, roles from different clients or audiences.
      </p>
      <syn-button
        [routerLink]="['/', 'clients', id, 'mappers', 'new']"
      >
        <syn-icon name="add_fill" slot="prefix" />
        <span i18n="@@add-token-mapper">Add Token Mapper</span>
      </syn-button>
    </div>

    <app-table
      [columns]="columns"
      [values]="mappers()"
      [clickable]="true"
      (selectValue)="onSelectTokenMapper($event)"
    />
  `,
  styles: [
    `
    `,
  ],
  imports: [
    SynButtonComponent,
    SynIconComponent,
    TableComponent,
    RouterLink,
  ],
})
export class TokenMappersComponent {
  id = inject(ActivatedRoute).snapshot.params['id'];
  api = inject(ServicePortalApi);
  router = inject(Router);

  mappers = input.required<TokenMapper[]>();

  columns: ColumnDescription<TokenMapper>[] = [
    {
      label: $localize`:@@display-name:Display Name`,
      getField: (mapper) => mapper.displayName,
      style: 'width: 50%',
    },
    {
      label: $localize`:@@mapper-type:Mapper Type`,
      getField: (mapper) => {
        if (mapper.session) return 'Session';
        if (mapper.userAttribute) return 'User Attribute';
        if (mapper.audience) return 'Audience';
        if (mapper.realmRoles) return 'Realm Roles';
        if (mapper.clientRoles) return 'Client Roles';
        return 'Unknown';
      },
      style: 'width: 50%',
    },
  ];

  onSelectTokenMapper(mapper: TokenMapper) {
    void this.router.navigate(['clients', this.id, 'mappers', mapper.id]);
  }
}
